/* 4Women — Selector de packs en la ficha. Dos pasos.
 *
 * Vivia inline dentro de snippets/fw-packs.liquid. Se movio aqui porque el
 * quick-add de coleccion trae la ficha por fetch + DOMParser y la inyecta con
 * morph: un <script> que llega por innerHTML no se ejecuta. Ahi dentro el
 * selector quedaba inerte y la clienta que elegia 3 unidades se llevaba 1, sin
 * ningun error visible.
 *
 * Todo lo de aqui delega sobre document, asi que una sola carga cubre las
 * fichas inyectadas igual que las servidas.
 *
 * ============================================================
 * ARREGLO 09/09/2026: EL PACK DE 2 AGREGABA 4
 * ============================================================
 *
 * Reportado por Gabriel como "una vez seleccionado el principal agrega triple
 * si marco el de 2". Medido en el tema lanzamiento nueva, ballet-wrap-negra,
 * tramo de 2 con la segunda prenda en otro color:
 *
 *     esperado   Negra x1 + Coffee x1   = 2
 *     real       Negra x3 + Coffee x1   = 4
 *
 * Se agregaba DOS VECES. El tema mandaba el formulario nativo con el campo
 * `quantity` en 2, y encima este archivo hacia su propio /cart/add.js con el
 * pack armado. La prenda principal quedaba en 1 + 2 = 3, de ahi el "triple".
 *
 * La causa esta en una suposicion equivocada que estaba escrita aqui mismo:
 * "la fase de captura de un ancestro corre siempre antes que los oyentes del
 * propio formulario, asi que no depende del orden en que el tema registre el
 * suyo". Es falso para este tema. Horizon no escucha en el formulario: registra
 * UN oyente delegado en document Y TAMBIEN en captura (assets/component.js,
 * registerEventListeners, `{ capture: true }`) que resuelve los atributos
 * `on:submit`. O sea los dos oyentes viven en el MISMO nodo y en la MISMA fase,
 * y ahi `stopPropagation()` no sirve: solo corta la propagacion al nodo
 * siguiente, nunca a un hermano registrado en el mismo. Para eso hace falta
 * `stopImmediatePropagation()`, y aun asi solo gana quien se registro primero,
 * que es una carrera entre un script `defer` y un modulo.
 *
 * Por eso ahora se corta ANTES, en el clic del boton de agregar: si ahi se
 * llama a preventDefault(), el navegador no llega a emitir ningun `submit` y el
 * oyente del tema no tiene nada que atender. No hay carrera que perder.
 *
 * El oyente de `submit` se conserva para el envio por teclado (Enter), que no
 * pasa por el clic. Ese sigue dependiendo del orden de registro, pero es un
 * caso de borde: el formulario de compra no tiene campos de texto donde pulsar
 * Enter tenga sentido.
 *
 * ============================================================
 * EL CAJON SI SE ABRE, Y ESO ESTA BIEN AQUI
 * ============================================================
 *
 * `cart:update` abre el cajon cuando el ajuste auto_open_cart_drawer esta
 * encendido: en events.js `CartAddEvent.eventName` ES `ThemeEvents.cartUpdate`,
 * los dos nombres son la misma cadena. En este bloque se quiere: la clienta
 * acaba de tocar "Agregar al carrito", asi que ver el carrito es exactamente lo
 * que espera, igual que en cualquier otro producto de la tienda. (En el
 * quick-add del abrigo se quiere lo contrario y por eso alli se le quita el
 * atributo al cajon mientras se emite; ver fw-abrigo-quickadd.js.)
 */
(() => {
  if (window.__fwPacks) return;
  window.__fwPacks = true;

  /* La eleccion se guarda por producto: el tema rehace parte de la ficha
     al cambiar de talla o color y si no, el selector volvia a 1 unidad. */
  const memoria = new Map();

  /* Composicion del pack: una entrada por prenda, {h: handle, id: variante,
     tocado: si la clienta la cambio a mano}. Las que no toco siguen a la
     seleccion de arriba; las que toco se quedan quietas. */
  const armado = new WeakMap();

  const catalogo = (raiz) => {
    if (raiz.__cat) return raiz.__cat;
    try {
      raiz.__cat = JSON.parse(raiz.querySelector('[data-fw-catalogo]').textContent);
    } catch (e) {
      raiz.__cat = { colores: [] };
    }
    return raiz.__cat;
  };

  /* La variante vigente se lee del campo del formulario y no de un atributo
     propio: ese campo es el que el tema mantiene al dia al cambiar de talla,
     y es el mismo que viajaria al carrito por el camino nativo. */
  const varianteActual = (raiz) => {
    const form = raiz.closest('form');
    const campo = form && form.querySelector('[name="id"]');
    return campo ? String(campo.value) : '';
  };

  const color = (raiz, handle) => {
    const cat = catalogo(raiz);
    return cat.colores.find((c) => c.h === handle) || cat.colores[0];
  };

  const colorDeVariante = (raiz, id) =>
    catalogo(raiz).colores.find((c) => c.tallas.some((t) => String(t.id) === String(id)));

  const primeraDisponible = (c) => {
    const t = c.tallas.find((x) => x.d) || c.tallas[0];
    return t ? String(t.id) : '';
  };

  const porDefecto = (raiz) => {
    const id = varianteActual(raiz);
    const c = colorDeVariante(raiz, id) || color(raiz, raiz.dataset.handle);
    return { h: c ? c.h : raiz.dataset.handle, id: id || (c ? primeraDisponible(c) : ''), tocado: false };
  };

  /* Una prenda esta "lista" si su variante existe en el catalogo y esta
     disponible. Se mira la disponibilidad y no solo que haya un id porque una
     talla se puede agotar entre que se pinto la ficha y que la clienta agrega,
     y un pack con una prenda agotada no se puede cumplir. */
  const lista = (raiz, u) => {
    const c = color(raiz, u.h);
    const t = c && c.tallas.find((x) => String(x.id) === String(u.id));
    return !!(t && t.d);
  };

  const etiqueta = (texto) => {
    const s = document.createElement('span');
    s.className = 'fw-packs__u-et';
    s.textContent = texto;
    return s;
  };

  const pintar = (raiz, cantidad) => {
    const caja = raiz.querySelector('[data-fw-armar]');
    const cont = raiz.querySelector('[data-fw-us]');
    const cat = catalogo(raiz);
    if (!caja || !cont || !cat.colores.length) return;

    if (cantidad < 2) {
      caja.hidden = true;
      cont.textContent = '';
      armado.delete(raiz);
      return;
    }

    const base = porDefecto(raiz);
    const previo = armado.get(raiz) || [];
    const est = [];
    for (let i = 0; i < cantidad; i++) {
      const p = previo[i];
      est.push(p && p.tocado ? p : { h: base.h, id: base.id, tocado: false });
    }
    armado.set(raiz, est);

    cont.textContent = '';
    est.forEach((u, i) => {
      const c = color(raiz, u.h);
      if (!c) return;
      const talla = c.tallas.find((t) => String(t.id) === String(u.id));

      const li = document.createElement('li');
      li.className = 'fw-packs__u';
      li.dataset.i = String(i);

      /* Cabecera: numero, la palabra Prenda y a la derecha lo elegido. Poder
         revisar las tres de un vistazo, sin leer los controles. */
      const cab = document.createElement('span');
      cab.className = 'fw-packs__u-n';
      const num = document.createElement('span');
      num.className = 'fw-packs__u-i fw-num';
      num.textContent = String(i + 1);
      cab.appendChild(num);
      cab.appendChild(document.createTextNode('Prenda'));
      const sel = document.createElement('span');
      sel.className = 'fw-packs__u-sel';
      sel.textContent = c.n + (talla ? ' · ' + talla.t : '');
      cab.appendChild(sel);
      li.appendChild(cab);

      li.appendChild(etiqueta('Color'));
      const cols = document.createElement('div');
      cols.className = 'fw-packs__cols';
      cols.setAttribute('role', 'radiogroup');
      cols.setAttribute('aria-label', 'Color de la prenda ' + (i + 1));
      cat.colores.forEach((cc) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fw-packs__c';
        b.dataset.h = cc.h;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', cc.h === u.h ? 'true' : 'false');

        const punto = document.createElement('span');
        punto.className = 'fw-packs__c-p';
        if (cc.img) {
          const im = document.createElement('img');
          im.src = cc.img;
          im.alt = '';
          /* eager y no lazy: estas fotos se crean en el momento en que la
             clienta elige un tramo, o sea que nacen ya dentro de la pantalla.
             Con lazy el navegador tiene que decidir si estan visibles antes de
             pedirlas, y mientras tanto se ven puntos vacios justo cuando acaba
             de tocar. Son 18px. */
          im.loading = 'eager';
          im.width = 18;
          im.height = 18;
          punto.appendChild(im);
        } else {
          punto.style.background = cc.sw || '#ccc';
        }
        b.appendChild(punto);
        /* El nombre al lado del punto, como en la referencia. Con solo la foto,
           "Café" y "Cherry Dark" en 18px son dos circulos oscuros iguales. */
        b.appendChild(document.createTextNode(cc.n));
        cols.appendChild(b);
      });
      li.appendChild(cols);

      li.appendChild(etiqueta('Talla'));
      const tals = document.createElement('div');
      tals.className = 'fw-packs__tals';
      tals.setAttribute('role', 'radiogroup');
      tals.setAttribute('aria-label', 'Talla de la prenda ' + (i + 1));
      c.tallas.forEach((t) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fw-packs__t';
        b.dataset.id = String(t.id);
        b.textContent = t.t;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(t.id) === String(u.id) ? 'true' : 'false');
        if (!t.d) {
          b.disabled = true;
          b.setAttribute('aria-label', t.t + ' agotada');
        }
        tals.appendChild(b);
      });
      li.appendChild(tals);

      cont.appendChild(li);
    });

    /* Contador de avance. Aca casi siempre dira "3 de 3 listas" porque el paso
       2 nace relleno; sirve cuando una talla se agoto y hay que arreglarla, y
       de paso confirma en una linea que el pack se puede comprar. */
    const listas = est.filter((u) => lista(raiz, u)).length;
    const txt = raiz.querySelector('[data-fw-progreso]');
    const barra = raiz.querySelector('[data-fw-barra]');
    if (barra) barra.style.inlineSize = Math.round((listas / est.length) * 100) + '%';
    if (txt) {
      /* Las cifras van envueltas en .fw-num: en esta marca TODOS los numeros de
         la web van en Lato, y este renglon se pintaba desde JS con
         textContent, o sea heredando la Raleway del texto que lo rodea. Es
         innerHTML y no textContent porque hay que insertar el envoltorio; los
         valores son numeros calculados aqui, no texto de nadie. */
      const num = (v) => '<span class="fw-num">' + v + '</span>';
      if (listas === est.length) {
        txt.innerHTML = num(listas) + ' de ' + num(est.length) + ' listas';
      } else {
        const falta = est.findIndex((u) => !lista(raiz, u)) + 1;
        txt.innerHTML = num(listas) + ' de ' + num(est.length) + ' listas · revisa la prenda ' + num(falta);
      }
    }

    /* El atajo solo aparece cuando hay algo que emparejar. Con las tres iguales
       —el 95% de los casos— seria un enlace que no hace nada. */
    const rep = raiz.querySelector('[data-fw-repetir]');
    if (rep) {
      const todasIguales = est.every((u) => u.h === est[0].h && String(u.id) === String(est[0].id));
      rep.hidden = todasIguales;
      if (!todasIguales) {
        const c0 = color(raiz, est[0].h);
        const t0 = c0 && c0.tallas.find((x) => String(x.id) === String(est[0].id));
        rep.textContent = 'Repetir ' + (c0 ? c0.n : '') + (t0 ? ' ' + t0.t : '') + ' en todas';
      }
    }

    caja.hidden = false;
  };

  const aplicar = (raiz, cantidad) => {
    const campo = raiz.querySelector('[data-fw-qty]');
    if (campo) campo.value = cantidad;

    raiz.querySelectorAll('.fw-packs__op').forEach((op) => {
      const radio = op.querySelector('input');
      const activo = Number(radio.value) === Number(cantidad);
      radio.checked = activo;
      op.classList.toggle('is-on', activo);
    });

    memoria.set(raiz.dataset.producto, String(cantidad));

    pintar(raiz, Number(cantidad));
  };

  document.addEventListener('change', (evento) => {
    const radio = evento.target instanceof Element && evento.target.closest('.fw-packs__op input');
    if (!radio) return;
    aplicar(radio.closest('fw-packs'), radio.value);
  });

  document.addEventListener('click', (evento) => {
    const t = evento.target instanceof Element ? evento.target : null;
    if (!t) return;

    const rep = t.closest('[data-fw-repetir]');
    if (rep) {
      const raiz = rep.closest('fw-packs');
      const est = armado.get(raiz);
      if (!est || !est.length) return;
      /* Todas quedan marcadas como tocadas: la clienta acaba de decidir a mano
         que quiere las tres iguales, y si no, el siguiente repintado las
         volveria a enganchar a la seleccion de arriba. */
      const uno = est[0];
      est.forEach((u) => {
        u.h = uno.h;
        u.id = uno.id;
        u.tocado = true;
      });
      armado.set(raiz, est);
      pintar(raiz, est.length);
      return;
    }

    const chip = t.closest('.fw-packs__c, .fw-packs__t');
    if (!chip) return;

    const raiz = chip.closest('fw-packs');
    const fila = chip.closest('.fw-packs__u');
    if (!raiz || !fila) return;
    const est = armado.get(raiz);
    if (!est) return;

    const i = Number(fila.dataset.i);
    const u = est[i];
    if (!u) return;

    if (chip.classList.contains('fw-packs__c')) {
      const nuevo = color(raiz, chip.dataset.h);
      if (!nuevo) return;
      /* Al cambiar de color se conserva la talla si ese color la tiene
         disponible. Reiniciarla obligaria a volver a elegir lo que ya
         estaba elegido, que es la friccion que hace abandonar el pack. */
      const anterior = color(raiz, u.h);
      const previa = anterior && anterior.tallas.find((x) => String(x.id) === String(u.id));
      const igual = previa && nuevo.tallas.find((x) => x.t === previa.t && x.d);
      u.h = nuevo.h;
      u.id = igual ? String(igual.id) : primeraDisponible(nuevo);
    } else {
      if (chip.disabled) return;
      u.id = String(chip.dataset.id);
    }

    u.tocado = true;
    armado.set(raiz, est);
    pintar(raiz, est.length);
  });

  document.addEventListener('variant:update', () => {
    requestAnimationFrame(() => {
      document.querySelectorAll('fw-packs').forEach((raiz) => {
        const guardada = memoria.get(raiz.dataset.producto);
        if (guardada) aplicar(raiz, guardada);
      });
    });
  });

  /* ---------- Agregar al carrito con el pack armado ----------
   *
   * Si las prendas terminan siendo todas la misma variante que ya esta
   * seleccionada arriba NO se intercepta: ese es el camino nativo del tema, que
   * ya esta probado contra carritos reales y ademas manda `quantity` con el
   * numero correcto. Solo se toma el control cuando hay mas de una variante
   * distinta, que es lo unico que el formulario nativo no sabe mandar. */
  const plan = (form) => {
    const raiz = form.querySelector('fw-packs');
    if (!raiz || raiz.__fwEnviando) return null;

    const est = armado.get(raiz);
    const campo = raiz.querySelector('[data-fw-qty]');
    const cantidad = Number((campo && campo.value) || 1);
    if (!est || cantidad < 2 || est.length !== cantidad) return null;

    /* Las prendas que la clienta no toco se resuelven AQUI contra la variante
       vigente, no contra la ultima pintada. Arreglo del 02/10/2026: la barra
       fija del celular marca la talla y pulsa el boton en el mismo gesto, y el
       repintado (que va en requestAnimationFrame tras `variant:update`) puede
       llegar despues. Medido en el vivo con un pack de 3 mezclado: talla M en
       la barra, la prenda sin tocar se iba en S y despues la ficha la mostraba
       en M. En un telefono lento pasa lo mismo con la talla de arriba. */
    const actual = varianteActual(raiz);
    const ids = est.map((u) => String(u.tocado ? u.id : actual || u.id));
    if (ids.some((id) => !id)) return null;
    if (ids.every((id) => id === ids[0]) && ids[0] === actual) return null;

    return { raiz, ids };
  };

  /* En el CLIC, no en el submit: cancelando aqui el navegador no llega a emitir
     ningun evento `submit`, asi que el oyente delegado del tema no tiene nada
     que atender. Ver la nota larga de la cabecera. */
  document.addEventListener(
    'click',
    (evento) => {
      const t = evento.target instanceof Element ? evento.target : null;
      if (!t) return;
      const boton = t.closest('button[type="submit"], input[type="submit"], button:not([type])');
      if (!boton) return;
      const form = boton.form || boton.closest('form');
      if (!form) return;
      const p = plan(form);
      if (!p) return;

      evento.preventDefault();
      evento.stopImmediatePropagation();
      agregar(p.raiz, form, p.ids);
    },
    true
  );

  /* Envio por teclado. Este si depende del orden de registro contra el oyente
     del tema, pero es un caso de borde: el formulario de compra no tiene campos
     de texto donde pulsar Enter tenga sentido. */
  document.addEventListener(
    'submit',
    (evento) => {
      const form = evento.target;
      if (!(form instanceof HTMLFormElement)) return;
      const p = plan(form);
      if (!p) return;

      evento.preventDefault();
      evento.stopImmediatePropagation();
      agregar(p.raiz, form, p.ids);
    },
    true
  );

  async function agregar(raiz, form, ids) {
    const items = [];
    ids.forEach((id) => {
      const ya = items.find((it) => it.id === id);
      if (ya) ya.quantity += 1;
      else items.push({ id: id, quantity: 1 });
    });

    const boton = form.querySelector('[ref="addToCartButton"], button[type="submit"]');
    raiz.__fwEnviando = true;
    raiz.setAttribute('aria-busy', 'true');
    if (boton) boton.setAttribute('disabled', 'true');

    try {
      const ruta = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const res = await fetch(ruta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      const datos = await res.json();
      if (!res.ok || (datos && datos.status)) {
        throw new Error((datos && (datos.description || datos.message)) || 'cart/add');
      }

      /* Mismo nombre de evento que emite el tema al agregar. Sin `sections` en
         el detalle el carrito se vuelve a pedir al servidor solo: una peticion
         mas, pero nada que mantener en espejo si el tema cambia su markup. Es
         tambien lo que abre el cajon, que aqui es lo que se busca. */
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: 'fw-packs',
            data: {
              source: 'product-form-component',
              itemCount: ids.length,
              productId: raiz.dataset.producto,
            },
          },
        })
      );
    } catch (error) {
      /* No se cae al camino nativo a proposito: agregaria N veces la misma
         variante, que no es lo que la clienta armo. Mejor que el boton
         vuelva a estar vivo y pueda reintentar. */
      console.error('[fw-packs] no se pudo agregar el pack', error);
    } finally {
      raiz.__fwEnviando = false;
      raiz.removeAttribute('aria-busy');
      if (boton) boton.removeAttribute('disabled');
    }
  }
})();
